import React, { useCallback, useContext, useEffect } from 'react';
import useStyles from '../../../style/js-style/containers/administration/consumption/ConsumptionStyle';
import { Grid } from '@mui/material';
import i18next from 'i18next';
import { Context } from '../../../states/Store';
import { ERROR } from '../../../services/common/Constants';
import { getAccountConsumption } from '../../../services/edge/ConsumptionService';
import { theme } from '../../../style/globalStyle';
import { getApiErrorMessageCode } from '../../../services/common/ApiUtils';
import EAStatistic from '../../../components/common/EAStatistic';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import moment from 'moment';

const getCurrentPeriodConsumptionTextColor = (consumptionStatus) => {
  switch (consumptionStatus) {
    case 'WARNING':
      return theme.palette.warning.main;
    case 'REACHED':
      return theme.palette.error.main;
    case 'OK':
      return theme.palette.success.main;
    default:
      return theme.palette.text.secondary;
  }
};

function Consumption() {
  const { classes } = useStyles();
  const [isLoading, setIsLoading] = React.useState(true);
  const [consumption, setConsumption] = React.useState();
  const [state, dispatch] = useContext(Context);

  const fetchConsumption = useCallback(() => {
    if (state.account) {
      setIsLoading(true);
      (async function fetchData() {
        try {
          const resp = await getAccountConsumption(state.account.id);
          setIsLoading(false);
          setConsumption(resp.content);
        } catch (error) {
          dispatch({
            type: 'ALERT',
            alert: { type: ERROR, msg: getApiErrorMessageCode(error) },
          });
          setIsLoading(false);
        }
      })();
    }
  }, [dispatch, state.account]);

  useEffect(() => {
    fetchConsumption();
  }, [fetchConsumption]);

  return (
    <div className={classes.container}>
      <Grid container spacing={4} className={classes.gridContainer}>
        <Grid item size={6} className={classes.gridItem}>
          <EAStatistic
            title={i18next.t('consumption.thirdPartyCountLabel')}
            subtitle={
              consumption?.periodStartDate &&
              consumption?.periodEndDate &&
              `${moment(consumption.periodStartDate).format(
                'DD/MM/YYYY'
              )} - ${moment(consumption.periodEndDate).format('DD/MM/YYYY')}`
            }
            value={consumption?.thirdPartyCount}
            isLoading={isLoading}
            valueColor={getCurrentPeriodConsumptionTextColor(
              consumption?.status
            )}
            icon={<TrendingUpIcon fontSize="large" color="action" />}
          />
        </Grid>
        <Grid item size={6} className={classes.gridItem}>
          <EAStatistic
            title={i18next.t('consumption.thirdPartyThresholdLabel')}
            value={
              consumption?.thirdPartyThreshold ??
              i18next.t('consumption.noThirdPartyThresholdLabel')
            }
            isLoading={isLoading}
            icon={
              <ProductionQuantityLimitsIcon fontSize="large" color="action" />
            }
          />
        </Grid>
      </Grid>
    </div>
  );
}

export default Consumption;
